const description = {
    email: 'email',
    phone_number: 'số điện thoại',
    username: 'tên đăng nhập',
    reminder: 'Nhắc nhở',
    not_found: '404 Không tìm thấy',
    agree_with_terms: 'Tôi đã đọc và đồng ý với ',
    agree_with_terms_modal: 'Để tiếp tục, vui lòng đồng ý với <link></link>.',
    terms_of_use: 'Điều khoản sử dụng',
    sign_in: 'Đăng nhập',
    privacy_policy: 'Chính sách bảo mật',
    create_account: 'Tạo tài khoản',
    switch_account: 'Chuyển tài khoản',
    or: 'hoặc',
    and: 'và',
    enter_passcode: 'Mã xác minh đã được gửi đến {{address}} {{target}} của bạn',
    passcode_sent: 'Mã xác minh đã được gửi lại',
    resend_after_seconds: 'Chưa nhận được mã? Gửi lại sau <span>{{seconds}}</span> giây',
    resend_passcode: 'Chưa nhận được mã? <a>Gửi lại mã xác minh</a>',
    create_account_id_exists: 'Đã có tài khoản với {{value}}. Tiếp tục để đăng nhập.',
    link_account_id_exists: 'Tài khoản với {{type}} {{value}} đã tồn tại. Bạn có muốn liên kết không?',
    sign_in_id_does_not_exist: 'Không tìm thấy tài khoản với {{value}}. Tạo tài khoản mới?',
    sign_in_id_does_not_exist_alert: 'Tài khoản với {{type}} {{value}} không tồn tại.',
    create_account_id_exists_alert: 'Tài khoản với {{type}} {{value}} đã được liên kết với tài khoản khác. Vui lòng thử {{type}} khác.',
    social_identity_exist: '{{type}} {{value}} đã được liên kết với tài khoản khác. Vui lòng thử {{type}} khác.',
    bind_account_title: 'Liên kết hoặc tạo tài khoản',
    social_create_account: 'Bạn có thể tạo tài khoản mới.',
    social_link_email: 'Bạn có thể liên kết email khác',
    social_link_phone: 'Bạn có thể liên kết số điện thoại khác',
    social_link_email_or_phone: 'Bạn có thể liên kết email hoặc số điện thoại khác',
    social_bind_with_existing: 'Chúng tôi tìm thấy một tài khoản liên quan đã được đăng ký, bạn có thể liên kết ngay.',
    skip_social_linking: 'Bỏ qua liên kết với tài khoản hiện có?',
    reset_password: 'Đặt lại mật khẩu',
    reset_password_description: 'Nhập {{types, list(type: disjunction;)}} liên kết với tài khoản của bạn, chúng tôi sẽ gửi mã xác minh để đặt lại mật khẩu.',
    reset_password_magic_link_description: 'Nhập địa chỉ email liên kết với tài khoản của bạn để tiếp tục đặt lại mật khẩu.',
    new_password: 'Mật khẩu mới',
    set_password: 'Đặt mật khẩu',
    password_changed: 'Mật khẩu đã được đổi',
    no_account: 'Chưa có tài khoản? ',
    have_account: 'Đã có tài khoản?',
    enter_password: 'Nhập mật khẩu',
    enter_password_for: 'Đăng nhập bằng mật khẩu với {{method}} {{value}}',
    enter_username: 'Đặt tên đăng nhập',
    enter_username_description: 'Tên đăng nhập là một cách khác để đăng nhập. Tên đăng nhập chỉ được chứa chữ cái, số, gạch dưới, gạch ngang và dấu chấm.',
    enter_username_policy_description: 'Tên đăng nhập là một cách khác để đăng nhập. {{requirements}}',
    link_email: 'Liên kết email',
    link_phone: 'Liên kết số điện thoại',
    link_email_or_phone: 'Liên kết email hoặc số điện thoại',
    link_email_description: 'Để tăng cường bảo mật, vui lòng liên kết email với tài khoản.',
    link_phone_description: 'Để tăng cường bảo mật, vui lòng liên kết số điện thoại với tài khoản.',
    link_email_or_phone_description: 'Để tăng cường bảo mật, vui lòng liên kết email hoặc số điện thoại với tài khoản.',
    continue_with_more_information: 'Để tăng cường bảo mật, vui lòng hoàn tất thông tin tài khoản dưới đây.',
    create_your_account: 'Tạo tài khoản của bạn',
    sign_in_to_your_account: 'Đăng nhập vào tài khoản của bạn',
    device_activation: 'Kích hoạt thiết bị',
    device_activation_description: 'Nhập mã hiển thị trên thiết bị của bạn. Đảm bảo mã khớp, sau đó tiếp tục đăng nhập vào thiết bị này.',
    device_activation_error_description: 'Nhập mã hiển thị trên thiết bị của bạn.',
    device_activation_success: 'Thiết bị của bạn đã được kết nối!',
    device_activation_success_description: 'Quay lại thiết bị của bạn để tiếp tục.',
    no_region_code_found: 'Không tìm thấy mã vùng',
    verify_email: 'Xác minh email của bạn',
    verify_phone: 'Xác minh số điện thoại của bạn',
    password_requirements: 'Mật khẩu {{items, list}}.',
    password_requirement: {
        length_one: 'yêu cầu tối thiểu {{count}} ký tự',
        length_two: 'yêu cầu tối thiểu {{count}} ký tự',
        length_few: 'yêu cầu tối thiểu {{count}} ký tự',
        length_many: 'yêu cầu tối thiểu {{count}} ký tự',
        length_other: 'yêu cầu tối thiểu {{count}} ký tự',
        character_types_one: 'phải chứa ít nhất {{count}} loại ký tự trong: chữ hoa, chữ thường, số và ký hiệu',
        character_types_two: 'phải chứa ít nhất {{count}} loại ký tự trong: chữ hoa, chữ thường, số và ký hiệu',
        character_types_few: 'phải chứa ít nhất {{count}} loại ký tự trong: chữ hoa, chữ thường, số và ký hiệu',
        character_types_many: 'phải chứa ít nhất {{count}} loại ký tự trong: chữ hoa, chữ thường, số và ký hiệu',
        character_types_other: 'phải chứa ít nhất {{count}} loại ký tự trong: chữ hoa, chữ thường, số và ký hiệu',
    },
    username_requirements: 'Tên đăng nhập {{items, list}}.',
    username_requirement: {
        length: 'phải dài từ {{min}} đến {{max}} ký tự',
        characters: 'chỉ được chứa {{characters, list}}',
    },
    username_character: {
        uppercase: 'chữ hoa',
        lowercase: 'chữ thường',
        number: 'số',
        underscore: 'gạch dưới',
    },
    use: 'Dùng',
    single_sign_on_email_form: 'Nhập địa chỉ email doanh nghiệp của bạn',
    single_sign_on_connectors_list: 'Doanh nghiệp của bạn đã bật đăng nhập một lần (SSO) cho tài khoản email {{email}}. Bạn có thể tiếp tục đăng nhập bằng các nhà cung cấp SSO sau.',
    single_sign_on_enabled: 'Đăng nhập một lần (SSO) đã được bật cho tài khoản này',
    authorize_title: 'Cấp quyền cho {{name}}',
    unregistered_client_notice: 'Ứng dụng này tự khai báo bởi <hostname>{{host}}</hostname>, bao gồm cả tên và logo. Vui lòng kiểm tra tên miền trước khi tiếp tục.',
    request_permission: '{{name}} đang yêu cầu quyền truy cập vào:',
    grant_organization_access: 'Cấp quyền truy cập tổ chức:',
    authorize_personal_data_usage: 'Cho phép sử dụng dữ liệu cá nhân của bạn:',
    authorize_organization_access: 'Cho phép truy cập vào tổ chức cụ thể:',
    user_scopes: 'Dữ liệu người dùng cá nhân',
    organization_scopes: 'Quyền truy cập tổ chức',
    authorize_agreement: `Khi cấp quyền truy cập, bạn đồng ý với <link></link> của {{name}}.`,
    authorize_agreement_with_redirect: `Khi cấp quyền truy cập, bạn đồng ý với <link></link> của {{name}}, và sẽ được chuyển hướng đến {{uri}}.`,
    not_you: 'Không phải bạn?',
    user_id: 'Mã người dùng: {{id}}',
    redirect_to: 'Bạn sẽ được chuyển hướng đến {{name}}.',
    auto_agreement: 'Khi tiếp tục, bạn đồng ý với <link></link>.',
    identifier_sign_in_description: 'Nhập {{types, list(type: disjunction;)}} của bạn để đăng nhập.',
    all_sign_in_options: 'Tất cả tùy chọn đăng nhập',
    identifier_register_description: 'Nhập {{types, list(type: disjunction;)}} của bạn để tạo tài khoản mới.',
    all_account_creation_options: 'Tất cả tùy chọn tạo tài khoản',
    back_to_sign_in: 'Quay lại đăng nhập',
    password_expired: 'Mật khẩu của bạn đã hết hạn và phải được đặt lại trước khi đăng nhập.',
    password_expiration_reset: 'Đặt lại mật khẩu',
    support_email: 'Email hỗ trợ: <link></link>',
    support_website: 'Trang web hỗ trợ: <link></link>',
    switch_account_title: 'Bạn đang đăng nhập với tư cách {{account}}',
    switch_account_description: 'Để tiếp tục, bạn sẽ được đăng xuất khỏi tài khoản hiện tại và tự động chuyển sang tài khoản mới.',
    about_yourself: 'Cho chúng tôi biết về bạn',
    verify_identity: 'Xác minh danh tính của bạn',
    choose_verification_method: 'Chọn cách bạn muốn đăng nhập',
    verification_method: {
        passkey: 'Passkey',
        passkey_description: 'Xác minh bằng thiết bị hoặc khóa cứng USB của bạn',
        password: 'Mật khẩu',
        password_description: 'Nhập mật khẩu của bạn',
        email_verification_code: 'Mã xác minh qua email',
        phone_verification_code: 'Mã xác minh qua điện thoại',
        verification_code_description: 'Gửi đến {{target}}',
    },
};
export default Object.freeze(description);
